import(/* webpackMode: "eager" */ "/app/apps/web/src/app/[locale]/not-found.tsx")